export default __webpack_public_path__ + "static/media/hector.c233b05f.jpg";